import { makeStyles } from '@material-ui/core/styles';
import JETLightPalette from '@src/themes/JETLightPalette.module.scss';
const useStyles = makeStyles(({ typography }) => ({
  title: {
    ...typography.h4,
    lineHeight: 1.5,
    color:JETLightPalette.contentDefault
  },
}));

export default useStyles;
